import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';

import { ChangeIndicatedPercent } from '../../../number';

function AssetItemHeaderChange(props) {
  let { value } = props;

  if (typeof value !== 'number') {
  	value = 0;
  }
  return (
    <ChangeIndicatedPercent value={value} withPlusSign />
  );
}

AssetItemHeaderChange.propTypes = {
  value: PropTypes.number,
};

export default pure(AssetItemHeaderChange);
